module.exports = __webpack_public_path__ + "img/hynm.cc256b5c.png";